import ReactDOM from "react-dom/client";
import App from "./App";
import "./brand.css";
import "./styles.css";
import { register } from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
/* Sin StrictMode: evita doble montaje en desarrollo con MindAR (cámara / WebGL). */
root.render(<App />);

register();
